import { services } from "onearm";
import { BaseState } from "onearm";

export default class LogoState extends BaseState {
    enter() {
        services.get("resources").load(["preloader"], {
            onLoaded: this.onLoaderComplete.bind(this),
            onProgress: this.onLoaderProgress.bind(this),
        });
    }

    onLoaderComplete() {
        this.owner.goTo("PreloaderState");
    }

    onLoaderProgress(progress) {
        if (this.scene) {
            this.scene.setProgress(progress * 100);
        }
    }
}
